import { Injectable } from '@angular/core';
import { ApiService } from "./api.base.service";
import { Organization, PagedOrganizationGridDto } from '../../models/organization-model';

@Injectable({ providedIn: "root" })
export class OrganizationService {
  baseUrl = "api/organization";

  constructor(private apiService: ApiService) { }

  async getOrganizationsWithRegisteredUsersAsync(page?: number, itemsPerPage?: number): Promise<PagedOrganizationGridDto> {
    return await this.apiService.get<PagedOrganizationGridDto>(`${this.baseUrl}/getOrganizationsWithRegisteredUsers/${page}/${itemsPerPage}`);
  }

}
